module.exports = __webpack_public_path__ + "static/media/PTMono-Regular.ded295e1.woff";